import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PowerplatformCopilotAuthenticationTypeEnum } from 'src/app/components/actions/powerplatform-actions/set-copilot-authentication/enums/enums';
import { SetCopilotAuthenticationActionDefinitionModel } from 'src/app/models/api/playbooks/actions/setCopilotAuthenticationProperties';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';

@Component({
  selector: 'app-set-copilot-authentication-action',
  templateUrl: './set-copilot-authentication-action.component.html',
  styleUrls: ['./set-copilot-authentication-action.component.scss'],
})
export class SetCopilotAuthenticationActionComponent implements OnInit {
  @Input() public fg: UntypedFormGroup;
  @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
  @Input() public triggerType: TriggerTypes;

  public hasChange = false;

  public selectedOption: PowerplatformCopilotAuthenticationTypeEnum;
  public powerplatformCopilotAuthenticationTypeEnum = PowerplatformCopilotAuthenticationTypeEnum;

  private _newSetCopilotAuthenticationActionDefinitionModel?: SetCopilotAuthenticationActionDefinitionModel;

  ngOnInit(): void {
    if (this.playbooksActionInput.actionDefinitionProperties) {
      this._newSetCopilotAuthenticationActionDefinitionModel = this.playbooksActionInput
        .actionDefinitionProperties as SetCopilotAuthenticationActionDefinitionModel;
      this.selectedOption = this._newSetCopilotAuthenticationActionDefinitionModel.authenticationType;
    }
    this.fg.addControl('authenticationType', new UntypedFormControl(this.selectedOption, [Validators.required]));
  }
}
